import {openUrl} from '@jobseeker/common-core/utils/common';
import {cleanUrl} from '@jobseeker/lotus/utils';

const getCourseDetailPageLink = (
  title: string,
  id: number,
  queryParams = {}
) => {
  const queryParamsString = new URLSearchParams(queryParams).toString();
  return `${process.env.NEXT_PUBLIC_LOAD_CONFIG}/course/${cleanUrl(
    title
  )}-${id}?${queryParamsString}`;
};

const openCourseDetailPage = (title: string, id: number, queryParams = {}) =>
  openUrl(getCourseDetailPageLink(title, id, queryParams));

export {getCourseDetailPageLink, openCourseDetailPage};
